import React from "react";

const HairDetoxSpaBook = () => {
  return (
    <div className="HairSalonInSahakaraHead">
      <h3>Book Your Appointment Today! </h3>
      <p>
        Don’t let buildup and pollution dull your shine. Visit SCENT’s{" "}
        <a href="https://scentlifestyle.com/">Hair Detox Spa in Bangalore</a> to
        experience a rejuvenating transformation. With our expert team, premium
        products, and a commitment to excellence, we’re here to help you unlock
        the full potential of your hair. Book your detox appointment today and
        take the first step toward healthier, more vibrant hair!
      </p>
      <br />
    </div>
  );
};

export default HairDetoxSpaBook;
